import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { NotificationConfigsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createNotificationConfig = (data): any => action(types.CREATE_NOTIFICATION_CONFIG_REQUESTED, data);

export const updateNotificationConfig = (data): any => action(types.UPDATE_NOTIFICATION_CONFIG_REQUESTED, data);

export const deleteNotificationConfig = (notificationConfigId): any => action(types.UPDATE_NOTIFICATION_CONFIG_REQUESTED, notificationConfigId);

export const getNotificationConfig = (notificationConfigId): any => action(types.GET_NOTIFICATION_CONFIG_REQUESTED, notificationConfigId);

export const getAllNotificationConfigs = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_NOTIFICATION_CONFIGS_REQUESTED, {
  pagination,
  compile,
});

export const selectNotificationConfig = (notificationConfigId): any => action(types.SELECT_NOTIFICATION_CONFIG_REQUESTED, {
  currentNotificationConfigId: notificationConfigId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createNotificationConfigPending: (payload): any => action(types.CREATE_NOTIFICATION_CONFIG_PENDING, payload),
  createNotificationConfigSuccess: (response): any => {
    const currentNotificationConfig = response.entities.notificationConfigs[response.result];
    // history.push(`/payment/${currentNotificationConfig.paymentCollection.id}/review`);
    return action(types.CREATE_NOTIFICATION_CONFIG_SUCCESS, {
      notificationConfigsById: response.entities.notificationConfigs,
      currentNotificationConfigId: response.result,
    });
  },
  updateNotificationConfigPending: (payload): any => action(types.UPDATE_NOTIFICATION_CONFIG_PENDING, payload),
  updateNotificationConfigSuccess: (response): any => action(types.UPDATE_NOTIFICATION_CONFIG_SUCCESS, {
    notificationConfigsById: response.entities.notificationConfigs,
    currentNotificationConfigId: response.result,
  }),
  updateNotificationConfigFailed: (error): any => action(types.UPDATE_NOTIFICATION_CONFIG_FAIL, {
    backendErrors: error,
  }),
  deleteNotificationConfigPending: (): any => action(types.UPDATE_NOTIFICATION_CONFIG_PENDING, {}),
  deleteNotificationConfigSuccess: (response, userId): any => {
    localStorage.set(userId, { currentNotificationConfigId: null });
    history.push('/notificationConfigs');

    return action(types.DELETE_NOTIFICATION_CONFIG_SUCCESS, {
      currentNotificationConfigId: response,
    });
  },
  getNotificationConfigPending: (): any => action(types.GET_NOTIFICATION_CONFIG_PENDING, {}),
  getNotificationConfigSuccess: (response): any => action(types.GET_NOTIFICATION_CONFIG_SUCCESS, {
    notificationConfigsById: response.entities.notificationConfigs,
    currentNotificationConfigId: response.result,
  }),
  getNotificationConfigFailed: (error): any => action(types.GET_NOTIFICATION_CONFIG_FAIL, {
    backendErrors: error,
  }),
  deleteNotificationConfigFailed: (error): any => action(types.UPDATE_NOTIFICATION_CONFIG_FAIL, {
    backendErrors: error,
  }),
  getAllNotificationConfigsPending: (pagination): any => action(types.GET_ALL_NOTIFICATION_CONFIGS_PENDING, { pagination }),
  getAllNotificationConfigsSuccess: (response, meta): any => action(types.GET_ALL_NOTIFICATION_CONFIGS_SUCCESS, {
    notificationConfigsById: response.entities.notificationConfigs,
    notificationConfigIds: response.result,
    meta,
  }),
  getAllNotificationConfigsFailed: (error): any => action(types.GET_ALL_NOTIFICATION_CONFIGS_FAIL, {
    backendErrors: error,
  }),
  createNotificationConfigFailed: (error): any => action(types.CREATE_NOTIFICATION_CONFIG_FAIL, {
    backendErrors: error,
  }),
};

export default null;
